export default {
  getReportDefinition: (state) => state.reportDefinition,
};
